import { render } from "./OtherAmountView.vue?vue&type=template&id=4b73902a&scoped=true&ts=true"
import script from "./OtherAmountView.vue?vue&type=script&lang=ts"
export * from "./OtherAmountView.vue?vue&type=script&lang=ts"

import "./OtherAmountView.vue?vue&type=style&index=0&id=4b73902a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b73902a"]])

export default __exports__